import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';
import { prepareFilterParams, prepareOptionFilterParams } from '@/libs/helper';

const resource = `${Config.basePath}/v1/admin/employee`;

export default {
  orgChart(payload) {
    const params = {
      sort: "asc",
      sortby: "manager_id",
      manager_id: payload.managerId,
      filtertype: "AND",
      filters: [{
        filtertype: "AND",
        filters: [{
          searchby: "deleted_at",
          searchoperator: payload.achieved ? "!=" : "=",
          search: null,
        }],
      }],
    }
    return Client.post(resource, params, {
      headers: {
        action: "org-chart",
      },
    });
  },
  index(payload) {
    payload.searchFields = [
      ...payload.searchFields,
    ];
    const params = prepareFilterParams(payload);
    return Client.post(resource, {
      ...params
    }, {
      headers: {
        action: "list",
      },
    });
  },
  show(id) {
    return Client.post(resource, {
      id: id,
    }, {
      headers: {
        action: "show",
      },
    });
  },
  create(payload) {
    const params = {
      ...payload,
    };
    return Client.post(resource, params, {
      headers: {
        action: "store",
      },
    });
  },
  update(id, payload) {
    const params = {
      ...payload,
      id: id,
    };
    return Client.post(resource, params, {
      headers: {
        action: "update",
      },
    });
  },
  options(payload) {
    const queries = [{
      searchby: "name",
      searchoperator: "%",
      search: payload.search
    }];
    const params = prepareOptionFilterParams(payload, queries);
    return Client.post(resource, params, {
      headers: {
        action: "option",
      },
    });
  },
};
